import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { VehiculoModel } from '../models/vehiculo.model';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { VehiculoSearchFilterModel } from '../models/vehiculo-search-filter-model';
import { PaginationModel } from '../models/pagination.model';

@Injectable({
  providedIn: 'root'
})
export class VehiculosService extends BaseService<VehiculoModel> {

  tipo: string;
  urlBase: string;
  constructor(protected httpClient: HttpClient) {
    super(httpClient);
    this.tipo = 'Vehiculo';
    this.urlBase = `${environment.baseApi}${environment.endPoints.vehiculos.base_vehiculos}`;
  }

  getVehiculoMe(id: number): Observable<VehiculoModel> {
    return this.httpClient.get<VehiculoModel>(`${this.urlBase}${environment.endPoints.vehiculos.me}/${id}`);
  }

  findByMatricula(matricula: string): Observable<VehiculoModel> {
    return this.httpClient.get<VehiculoModel>(`${this.urlBase}${environment.endPoints.vehiculos.matricula}?matricula=${matricula}`);
  }

  misVehiculos(): Observable<VehiculoModel[]> {
    return this.httpClient.get<VehiculoModel[]>(`${this.urlBase}${environment.endPoints.vehiculos.me}`);
  }

  updateMeVehiculo(vehiculo: VehiculoModel): Observable<VehiculoModel> {
    return this.httpClient.put<VehiculoModel>(`${this.urlBase}${environment.endPoints.vehiculos.me}`, vehiculo);
  }

  updateVehiculo(vehiculo: VehiculoModel): Observable<VehiculoModel> {
    return this.httpClient.patch<VehiculoModel>(`${this.urlBase}`, vehiculo);
  }

  aprobar(id: number): Observable<VehiculoModel> {
    return this.httpClient.put<VehiculoModel>(`${this.urlBase}/${id}${environment.endPoints.vehiculos.aprobacionVehiculo}`, '');
  }

  denegar(id: number): Observable<VehiculoModel> {
    return this.httpClient.put<VehiculoModel>(`${this.urlBase}/${id}${environment.endPoints.vehiculos.denegarVehiculo}`, '');

  }

  search(vehiculoBuscar: VehiculoSearchFilterModel, page: number): Observable<PaginationModel> {
    const params = this.generateParamSearch(vehiculoBuscar, page);
    return this.httpClient.get<PaginationModel>(`${this.urlBase}${environment.endPoints.vehiculos.busquedaVehiculos}?${params}`);
  }

  private generateParamSearch(vehiculoFilter: VehiculoSearchFilterModel, page: number): string {
    let params = `page=${page}&size=${environment.max_size_page_tables}&sortDirection=-1&sortField=propietario.usuario`;

    if (vehiculoFilter.estado) {
      params +=  `&idEstado=${vehiculoFilter.estado.id}`;
    }

    if (vehiculoFilter.tipoCombustible) {
      params +=  `&idTipoCombustible=${vehiculoFilter.tipoCombustible.id}`;
    }

    if (vehiculoFilter.tipoVehiculo) {
      params += `&idTipoVehiculo=${vehiculoFilter.tipoVehiculo.id}`;
    }

    if (vehiculoFilter.distintivoAmbiental) {
      params +=  `&idDistintivo=${vehiculoFilter.distintivoAmbiental.id}`;
    }

    if (vehiculoFilter.usoVehiculo) {
      params += `&idUsoVehiculo=${vehiculoFilter.usoVehiculo.id}`;
    }

    if (vehiculoFilter.clasificacion) {
      params += `&idClasificacion=${vehiculoFilter.clasificacion.id}`;
    }

    if (vehiculoFilter.sector) {
      params +=  `&idSector=${vehiculoFilter.sector.id}`;

    }

    if (vehiculoFilter.peso) {
      params +=  `&PMA=${vehiculoFilter.peso}`;

    }

    return params;
  }


}
